import axios from "axios";
import { storage } from '@/logic/storage'
import qs from 'qs'

const ENDPOINT_PATH = process.env.VUE_APP_API_URL;

export default {

    async setUserLogged(userLogged) {
        await storage.set('user', userLogged);
    },

    async setSettings(settings) {
        await storage.set('settings', settings);
    },
    async setPersonType(person_type) {
        await storage.set('person_type', person_type);
    },
    async setPhoto(photo) {
        await storage.set('photo', photo);
    },
    async setPersonName(name) {
        await storage.set('name', name);
    },
    async setToken(token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await storage.set('token', token);
    },
    async setRefreshToken(rt) {
        await storage.set('refresh_token', rt);
    },
    async getUserLogged() {
        return await storage.get('user');
    },
    async getSettings() {
        return await storage.get('settings');
    },
    async getPersonType() {
        return await storage.get('person_type');
    },
    async getPersonName() {
        return await storage.get('name');
    },
    async getPhoto() {
        return await storage.get('photo');
    },
    async getToken() {
        return await storage.get('token');
    },
    async getRefreshToken() {
        return await storage.get('refresh_token');
    },
    async register(email, password, person_type) {
        const user = { email, password, person_type };
        return await axios.post(ENDPOINT_PATH + "/signup", user);
    },
    async login(form) {
        return await axios.post(ENDPOINT_PATH + "/login", qs.stringify(form))
    },
    async checkRoles(email, password) {
        return await axios.post(ENDPOINT_PATH + "/check_roles", { email, password })
    },
    async setAvailableRoles(roles) {
        await storage.set('available_roles', roles);
    },
    async getAvailableRoles() {
        return await storage.get('available_roles');
    },
    async reset_pass(form) {
        return await axios.post(ENDPOINT_PATH + "/reset_request", qs.stringify(form))
    },

    async clearSession() {
        await storage.remove('token');
        await storage.remove('refresh_token');
        await storage.remove('user');
        await storage.remove('person_type');
        await storage.remove('name');
        await storage.remove('photo');
        await storage.remove('settings');
    },
    async logout() {

        const token = await this.getToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        try {
            const response = await axios.post(ENDPOINT_PATH + "/logout");
            if (response.status === 200) {
                await this.clearSession();
            }
            return response;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
}